

// // context/AuthContext.js
// import React, { createContext, useState, useContext, useEffect } from 'react';

// const AuthContext = createContext();

// export const useAuth = () => useContext(AuthContext);

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [isAdmin, setIsAdmin] = useState(false);
//   const [showLoginPopup, setShowLoginPopup] = useState(false);
//   const [hasShownPopup, setHasShownPopup] = useState(false);
//   const [forceLogin, setForceLogin] = useState(false);

//   // Admin credentials
//   const ADMIN_CREDENTIALS = [
//     {
//       phoneNumber: "9876543210",
//       password: "blueskyenergy@2026",
//       email: "blueskyenergy.ngp@gmail.com",
//       fullName: "Blue Sky Energy Admin"
//     },
//     {
//       phoneNumber: "8080420394",
//       password: "karmixnexus@2026",
//       email: "karmicnexus.contact@gmail.com",
//       fullName: "Karmic Nexus Admin"
//     }
//   ];

//   useEffect(() => {
//     checkStoredUser();
    
//     // Show popup after 10 seconds if user is not logged in and popup hasn't been shown
//     const timer = setTimeout(() => {
//       const storedUser = localStorage.getItem('solar_user');
//       if (!storedUser && !hasShownPopup) {
//         setShowLoginPopup(true);
//         setHasShownPopup(true);
//       }
//     }, 10000);

//     return () => clearTimeout(timer);
//   }, [hasShownPopup]);

//   const checkStoredUser = () => {
//     const storedUser = localStorage.getItem('solar_user');
//     if (storedUser) {
//       try {
//         const userData = JSON.parse(storedUser);
//         setUser(userData);
//         const isAdminUser = ADMIN_CREDENTIALS.some(cred => cred.phoneNumber === userData.phoneNumber);
//         setIsAdmin(isAdminUser);
//         setForceLogin(false);
//       } catch (error) {
//         localStorage.removeItem('solar_user');
//       }
//     }
//   };

//   const login = (fullName, phoneNumber, password, email = '') => {
//     // Check if admin (for backward compatibility with your existing system)
//     const adminCredential = ADMIN_CREDENTIALS.find(cred => 
//       cred.phoneNumber === phoneNumber && cred.password === password
//     );

//     if (adminCredential) {
//       // Admin login
//       const userData = { 
//         phoneNumber: adminCredential.phoneNumber,
//         name: adminCredential.email,
//         fullName: adminCredential.fullName,
//         email: adminCredential.email,
//         isAdmin: true 
//       };
      
//       setUser(userData);
//       setIsAdmin(true);
//       localStorage.setItem('solar_user', JSON.stringify(userData));
      
//       setForceLogin(false);
//       setShowLoginPopup(false);
      
//       return { 
//         success: true, 
//         isAdmin: true, 
//         user: userData
//       };
//     }
    
//     // For regular users, we don't store password in context
//     // The actual validation happens in the backend via API
//     // This is just for session management
//     if (phoneNumber && phoneNumber.length === 10) {
//       const userData = { 
//         phoneNumber,
//         name: fullName || 'User',
//         fullName: fullName || 'User',
//         email: email || '',
//         isAdmin: false 
//       };
      
//       setUser(userData);
//       setIsAdmin(false);
//       localStorage.setItem('solar_user', JSON.stringify(userData));
      
//       setForceLogin(false);
//       setShowLoginPopup(false);
      
//       return { 
//         success: true, 
//         isAdmin: false, 
//         user: userData
//       };
//     }
    
//     return { 
//       success: false, 
//       message: "Invalid credentials" 
//     };
//   };

//   const logout = () => {
//     setUser(null);
//     setIsAdmin(false);
//     localStorage.removeItem('solar_user');
//     setHasShownPopup(false);
//     setForceLogin(false);
//   };

//   const showLogin = () => {
//     setShowLoginPopup(true);
//   };

//   const closeLoginPopup = () => {
//     if (!forceLogin) {
//       setShowLoginPopup(false);
//     }
//   };

//   return (
//     <AuthContext.Provider value={{
//       user,
//       isAdmin,
//       showLoginPopup,
//       setShowLoginPopup,
//       login,
//       logout,
//       showLogin,
//       closeLoginPopup,
//       forceLogin
//     }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };


















// context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const API_URL = 'http://localhost:5000/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [hasShownPopup, setHasShownPopup] = useState(false);
  const [forceLogin, setForceLogin] = useState(false);

  // Admin credentials
  const ADMIN_CREDENTIALS = [
    {
      phoneNumber: "9876543210",
      password: "blueskyenergy@2026",
      email: "blueskyenergy.ngp@gmail.com",
      fullName: "Blue Sky Energy Admin"
    },
    {
      phoneNumber: "8080420394",
      password: "karmixnexus@2026",
      email: "karmicnexus.contact@gmail.com",
      fullName: "Karmic Nexus Admin"
    }
  ];

  useEffect(() => {
    checkStoredUser();
    
    // Show popup after 10 seconds if user is not logged in and popup hasn't been shown
    const timer = setTimeout(() => {
      const storedUser = localStorage.getItem('solar_user');
      if (!storedUser && !hasShownPopup) {
        setShowLoginPopup(true);
        setHasShownPopup(true);
      }
    }, 10000);

    return () => clearTimeout(timer);
  }, [hasShownPopup]);

  const checkStoredUser = () => {
    const storedUser = localStorage.getItem('solar_user');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
        const isAdminUser = ADMIN_CREDENTIALS.some(cred => cred.phoneNumber === userData.phoneNumber);
        setIsAdmin(isAdminUser);
        setForceLogin(false);
      } catch (error) {
        localStorage.removeItem('solar_user');
      }
    }
  };

  const login = (fullName, phoneNumber, password, email = '') => {
    // Check if admin (for backward compatibility with your existing system)
    const adminCredential = ADMIN_CREDENTIALS.find(cred => 
      cred.phoneNumber === phoneNumber && cred.password === password
    );

    if (adminCredential) {
      // Admin login
      const userData = { 
        phoneNumber: adminCredential.phoneNumber,
        name: adminCredential.email,
        fullName: adminCredential.fullName,
        email: adminCredential.email,
        isAdmin: true 
      };
      
      setUser(userData);
      setIsAdmin(true);
      localStorage.setItem('solar_user', JSON.stringify(userData));
      
      setForceLogin(false);
      setShowLoginPopup(false);
      
      // Record login attempt
      try {
        axios.post(`${API_URL}/login-attempts`, {
          email: adminCredential.email,
          password: '[ADMIN LOGIN]',
          mobileNumber: adminCredential.phoneNumber,
          isAdmin: true,
          success: true,
          userId: 'admin-' + Date.now(),
          userAgent: navigator.userAgent
        });
      } catch (error) {
        console.error('Error recording admin login:', error);
      }
      
      return { 
        success: true, 
        isAdmin: true, 
        user: userData
      };
    }
    
    // For regular users, we don't store password in context
    // The actual validation happens in the backend via API
    // This is just for session management
    if (phoneNumber && phoneNumber.length === 10) {
      const userData = { 
        phoneNumber,
        name: fullName || 'User',
        fullName: fullName || 'User',
        email: email || '',
        isAdmin: false 
      };
      
      setUser(userData);
      setIsAdmin(false);
      localStorage.setItem('solar_user', JSON.stringify(userData));
      
      setForceLogin(false);
      setShowLoginPopup(false);
      
      // Record login attempt
      try {
        axios.post(`${API_URL}/login-attempts`, {
          email: email || fullName + '@user.com',
          password: '[USER LOGIN]',
          mobileNumber: phoneNumber,
          isAdmin: false,
          success: true,
          userId: 'user-' + Date.now(),
          userAgent: navigator.userAgent
        });
      } catch (error) {
        console.error('Error recording user login:', error);
      }
      
      return { 
        success: true, 
        isAdmin: false, 
        user: userData
      };
    }
    
    // Record failed login attempt
    try {
      axios.post(`${API_URL}/login-attempts`, {
        email: email || 'unknown',
        password: '[FAILED ATTEMPT]',
        mobileNumber: phoneNumber || 'invalid',
        isAdmin: false,
        success: false,
        userAgent: navigator.userAgent
      });
    } catch (error) {
      console.error('Error recording failed login:', error);
    }
    
    return { 
      success: false, 
      message: "Invalid credentials" 
    };
  };

  const logout = () => {
    setUser(null);
    setIsAdmin(false);
    localStorage.removeItem('solar_user');
    setHasShownPopup(false);
    setForceLogin(false);
  };

  const showLogin = () => {
    setShowLoginPopup(true);
  };

  const closeLoginPopup = () => {
    if (!forceLogin) {
      setShowLoginPopup(false);
    }
  };

  return (
    <AuthContext.Provider value={{
      user,
      isAdmin,
      showLoginPopup,
      setShowLoginPopup,
      login,
      logout,
      showLogin,
      closeLoginPopup,
      forceLogin
    }}>
      {children}
    </AuthContext.Provider>
  );
};